import {h, Fragment} from "preact"
import { useFacets } from '@nosto/preact'
import Facet from './Facet'
import RangeFacet from './RangeFacet'
import { useEffect } from 'preact/hooks'

export default function SideBar() {
    const { loading, facets } = useFacets()

    useEffect(() => {
        const drawer = document.getElementById('nosto-facets-drawer')
        const closeButtons = document.querySelectorAll('.ns-close-overlay')
        const overlay = document.querySelector('.ns-sidebar-overlay')
        const sidebarContent = document.querySelector('.ns-sidebar-content')

        const handleClose = () => {
            if (drawer) {
                // Add the 'leave' class to trigger the closing animation
                drawer.classList.add('leave')
                sidebarContent?.classList.add('leave')

                // Wait for the animation to finish before removing the 'open' class
                const onAnimationEnd = () => {
                    drawer.classList.remove('open', 'leave')
                    sidebarContent?.classList.remove('leave')
                    drawer.removeEventListener('animationend', onAnimationEnd)
                }

                drawer.addEventListener('animationend', onAnimationEnd)
            }
        }

        // Attach event listeners to all close buttons
        closeButtons.forEach((button) => {
            button.addEventListener('click', handleClose)
        })
        overlay?.addEventListener('click', handleClose)

        return () => {
            // Clean up event listeners
            closeButtons.forEach((button) => {
                button.removeEventListener('click', handleClose)
            })
            overlay?.removeEventListener('click', handleClose)
        }
    }, [])

    return facets?.length > 0 ? (
        <div
            id="nosto-facets-drawer"
            class="nosto-facet facets-drawer drawer drawer--sm color-scheme color-scheme--dialog"
            role="dialog"
            aria-modal="true"
        >
            <div class="ns-sidebar-base">
                <div class="ns-sidebar-overlay"></div>
                <div class="ns-sidebar-content">
                    <header class="ns-sidebar-header">
                        <p class="h4" slot="header">
                            Filters
                        </p>
                        <div class="ns-sidebar-close-button-container">
                            <button class="ns-close-overlay ns-sidebar-close-button">
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="none"
                                    width="14"
                                    class="icon icon-close"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="m1 1 14 14M1 15 15 1"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    </header>

                    <div class="ns-sidebar-body">
                        <div class="facets">
                            <div class="accordion-list">
                                {facets?.map((facet) => {
                                    switch (facet.type) {
                                        case 'terms':
                                            return <Facet facet={facet} />
                                        case 'stats':
                                            return <RangeFacet facet={facet} />
                                        default:
                                            return null
                                    }
                                })}
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="ns-sidebar-footer">
                        <dialog-close-button class="contents">
                            <button type="button" class="ns-apply-filters button w-full">
                                View results
                            </button>
                        </dialog-close-button>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        ''
    )
}
